function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#2d2d2d;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "js");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M0,9.59H115.1v115.1H0ZM62.69,99.26V62.52H51.9V99.26c0,2.57-.52,4.32-1.54,5.27a6,6,0,0,1-4.24,1.41,5.76,5.76,0,0,1-4.24-1.54,13.08,13.08,0,0,1-2.83-3.86l-8.73,5.14q4.62,10,16.18,10,7.45,0,11.82-4.11T62.69,99.26ZM88.12,115.7q8,0,13-4t5-11.18q0-6.42-3.6-10.27-3.33-3.34-10.79-6.68l-2.57-1a23,23,0,0,1-5.26-3.08,4.95,4.95,0,0,1,0-6.94,5.3,5.3,0,0,1,3.72-1.29,7.48,7.48,0,0,1,4,1,8.61,8.61,0,0,1,3,3.6l8.48-5.4a16.48,16.48,0,0,0-6.3-6.68,18.63,18.63,0,0,0-9.12-2q-7.19,0-11.56,4.11a13.53,13.53,0,0,0-4.37,10.28,15,15,0,0,0,3.6,10.27q3.07,3.34,9.5,5.91l2.57,1.29a32.05,32.05,0,0,1,5.91,3.08,4.87,4.87,0,0,1,0,8,8.75,8.75,0,0,1-5.39,1.55q-6.42,0-10.54-6.68l-8.73,5.13a21.43,21.43,0,0,0,7.19,8A23.6,23.6,0,0,0,88.12,115.7Z",
  transform: "translate(0 -9.59)"
});

var SvgJs = function SvgJs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 115.1 115.1",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgJs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/js.0de98cbf.svg";
export { ForwardRef as ReactComponent };